import {FC} from 'react';
import {LoginModalInitialPageContentProps} from '@liveComponents/Auth/LoginModal';
import {Typography} from '@components/Typography';
import {Icon} from '@components/Icon';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {Button} from '@components/Button';
import {PromoCard} from '@components/PromoCard';
import {useAccountPackagesQuery} from "@gql/query/package/account.gql";
import {getGraphQlLocale} from "../../types/graphql/general";
import {useLocale} from "@utils/locale";
import {Currency} from "../../../.cache/__types__";

const ContactOwner: FC<LoginModalInitialPageContentProps> = (
    {
        onLogin,
        onRegister,
        currency,
        price
    }
) => {
    const locale = useLocale();
    const {data: premiumData} = useAccountPackagesQuery({
        variables: {
            locale: getGraphQlLocale(locale),
        },
    });

    return (
        <>
            <Typography as="p" textAlign="center" color="grey-dark" className="mb-8">
                <Icon.Star size="xl"/>
            </Typography>

            <Typography as="h3" variant="h4" textAlign="center" className="mb-8">
                <FormattedMessage
                    defaultMessage={'Pro kontaktování majitele je třeba se <strong>přihlásit a mít předplacený profil</strong>.'}
                    values={{
                        strong: (chunks: any) => <strong>{chunks}</strong>,
                    }}
                />
            </Typography>

            <Typography as="p" textAlign="center" className="mb-4">
                <Button onClick={onLogin}>
                    <FormattedMessage defaultMessage={'Přihlásit se'}/>
                </Button>
            </Typography>

            <Typography as="p" variant="perex" color="grey-dark" className="mb-8" textAlign="center">
                <FormattedMessage
                    defaultMessage={'Nemáte ještě účet? <link>Zaregistrujte se</link>'}
                    values={{
                        link: (chunks: any) => (
                            <a className={'link'} role={'button'} onClick={onRegister}>
                                {chunks}
                            </a>
                        ),
                    }}
                />
            </Typography>

            {premiumData && premiumData.packageList?.length && premiumData.packageList.length > 0 &&
                <PromoCard variant="green" size="sm" className="text-center">
                    <PromoCard.Desc>
                        <FormattedMessage
                            defaultMessage={
                                'RK byste za tuto nemovitost zaplatili provizi cca {provision_price}. U nás můžete za {premium_price} komunikovat se všemi majiteli.'
                            }
                            values={{
                                provision_price: <FormattedNumber value={price} currency={currency} style={"currency"}
                                                                  maximumFractionDigits={0}/>,
                                premium_price: <FormattedNumber value={premiumData.packageList.at(0)?.price ?? 0}
                                                                currency={premiumData.packageList.at(0)?.currency ?? Currency.Czk}
                                                                style={"currency"} maximumFractionDigits={0}/>,
                            }}
                        />
                    </PromoCard.Desc>
                </PromoCard>
            }
        </>
    );
}

export default ContactOwner;
